<template>
  <v-container class="fill-height">
    <v-app-bar v-if="loadingCurso">
      <v-skeleton-loader type="avatar, text" color="primary"></v-skeleton-loader>
    </v-app-bar>
    <v-app-bar v-if="!loadingCurso && curso" color="primary" :image="curso.imagen_url">
      <template v-slot:prepend>
        <v-avatar class="elevation-1" size="x-large" @click="selectModulo(null)">
          <img :src="curso.imagen_url" style="object-fit: cover; width: 100%; height: 100%;">
        </v-avatar>
      </template>
      <v-app-bar-title @click="selectModulo(null)">{{ curso.titulo }}</v-app-bar-title>
      <template v-slot:image>
        <v-img gradient="to right, rgba(0,0,0,.7), rgba(255,255,255,.7)"></v-img>
      </template>
      <v-btn v-if="selectedOption === 'editar'" color="primary" icon="mdi-cog" variant="text"
        @click="openEditDialog"></v-btn>
      <v-btn v-if="curso.id" color="primary" variant="text"
        :aria-label="t('Foro_obre_forum')" @click="foroVisible = true">
        <v-badge :content="noLlegitsForo > 99 ? '99+' : noLlegitsForo"
          :model-value="noLlegitsForo > 0" color="error" floating>
          <v-icon icon="mdi-forum-outline" />
        </v-badge>
        <span class="ml-2 hidden-sm-and-down">{{ t('Foro_titol') }}</span>
      </v-btn>
      <v-btn-toggle v-if="curso.docente_tiene_acceso" mandatory v-model="selectedOptionVista" color="primary" group>
        <v-btn v-for="option in optionsVista" :key="option.value" :value="option.value" variant="text">
          <span class="hidden-sm-and-down">{{ t(option.label) }}</span>
          <v-icon>
            {{ option.icon }}
          </v-icon>
        </v-btn>
      </v-btn-toggle>
      <template v-if="curso.permiso_edicion">
        <v-btn-toggle mandatory v-model="selectedOption" color="primary">
          <v-btn v-for="option in options" :key="option.value" :value="option.value" :icon="option.icon" variant="text">
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-app-bar>
    <v-dialog v-model="foroVisible" fullscreen scrollable>
      <ForoCurso v-if="foroVisible" :curso-id="cursoId" :visible="foroVisible"
        @cerrar="foroVisible = false" @novetats="noLlegitsForo = $event" />
    </v-dialog>
    <v-navigation-drawer v-model="drawer" :permanent="display.mdAndUp.value">
      <v-list nav v-if="loadingCurso || loadingModuls">
        <v-skeleton-loader type="avatar, text"></v-skeleton-loader>
      </v-list>
      <v-list nav v-if="!loadingCurso && !loadingModuls && !loadingEncuestas">
        <template v-if="selectedOptionVista === 'alumno' && progresoTeorico.total > 0">
          <div class="px-4 pb-4">
            <v-progress-circular :model-value="progresoTeorico.porcentaje" :size="69" :width="7"
              bg-color="surface-light" class="ma-3" color="orange-accent-2" rounded>
              <v-avatar color="surface-light" size="45">{{ progresoTeorico.porcentaje }}%</v-avatar>
            </v-progress-circular>
            {{ t('Completado') }}
          </div>
          <v-divider class="mb-2" />
        </template>
        <v-list-item v-for="(modulo, mI) in moduls.modulos" :key="modulo.id">
          <v-list-item @click="selectModulo(mI)" base-color="primary" :value="modulo" :active="moduloIndex === mI"
            :disabled="!modulo.activo && selectedOption == 'mirar'">{{ modulo.titulo
            }}
          </v-list-item>
          <template v-if="moduloIndex === mI && (modulo.activo || selectedOption == 'editar')">
            <v-list-item v-for="(leccion, lI) in modulo.lecciones" :key="leccion.id" @click="selectLeccion(mI, lI)"
              :value="leccion" :active="moduloIndex === mI && leccionIndex === lI">
              <v-list-item-title>{{ leccion.titulo }}</v-list-item-title>
              <template v-if="leccion.cuestionario" v-slot:append>
                <CuestionarioCurso :navbarra="true" :IDcuestionario="leccion.cuestionario"
                  :nota_usuario="leccion.nota_usuario" :IDleccion="leccion.id" :selectedOption="selectedOption"
                  :tipo_reto="leccion.tipo_reto" :selectedOptionVista="selectedOptionVista" :cursoId="cursoId"
                  @respuesta-enviada="fetchModuls" @nuevo-cuestionario="handleNuevoCuestionario"
                  @eliminar-cuestionario="handleEliminarCuestionario">
                </CuestionarioCurso>
              </template>
            </v-list-item>
            <v-list-item v-if="selectedOption === 'editar'" @click="() => openAddDialog('lecciones', modulo.id)">
              <v-list-item-title>{{ t('Anadir') }} {{ t('lección') }}</v-list-item-title>
              <template v-slot:append>
                <v-icon color="primary" icon="mdi-plus"></v-icon>
              </template>
            </v-list-item>
          </template>
        </v-list-item>
        <template v-if="selectedOption === 'editar'">
          <v-list-item @click="() => openAddDialog('modulos')">
            <v-list-item-title>{{ t('Anadir') }} {{ t('módulo') }}</v-list-item-title>
            <template v-slot:append>
              <v-icon color="secondary" icon="mdi-plus"></v-icon>
            </template>
          </v-list-item>
        </template>
        <EncuestaCurso :curso="curso" :encuestascurso="encuestascurso" :selectedOption="selectedOption"
          :navbarra="true">
        </EncuestaCurso>
      </v-list>
    </v-navigation-drawer>
    <v-row v-if="loadingCurso && !loadingModuls" align="center" justify="center">
      <v-skeleton-loader type="image, article"></v-skeleton-loader>
    </v-row>
    <v-row v-if="!loadingCurso && !loadingModuls && !loadingEncuestas">
      <v-alert v-if="selectedOption === 'editar' && selectedOptionVista === 'docente'"
        text="Atenció! Estàs editant la vista docent, visible només per a docents i administradors de l'activitat. Si vols editar la vista dels alumnes fes clic a Vista Alumne."></v-alert>
      <!-- Prova nou modul -->
      <ModuloLeccion v-if="leccionIndex === -1" :curso="curso" :moduls="moduls" :encuestas="encuestascurso"
        :moduloIndex="moduloIndex" :selectedOption="selectedOption" :selectedOptionVista="selectedOptionVista"
        :drawer="drawer" :progresoTeorico="progresoTeorico" @update:drawer="drawer = $event"
        @update-modulo="handleUpdateModulo" @delete-modulo="handleDeleteModulo" @reorder-modules="handleReorder"
        @refrescar="fetchModuls" @select-leccion="selectLeccion"></ModuloLeccion>
      <template v-else>
        <LeccionContent :curso="curso" :moduls="moduls" :moduloIndex="moduloIndex" :leccionIndex="leccionIndex"
          :selectedOption="selectedOption" :leccionActual="currentLeccion" @update-leccion="updateLeccion"
          @delete-leccion="selectPreviousLeccion" @reorder-lecciones="handleReorderL">
        </LeccionContent>
        <CuestionarioCurso :navbarra="false" :IDcuestionario="currentLeccion.cuestionario"
          :IDleccion="moduls.modulos[moduloIndex].lecciones[leccionIndex].id" :tipo_reto="currentLeccion.tipo_reto"
          :selectedOption="selectedOption" :selectedOptionVista="selectedOptionVista" :cursoId="cursoId"
          @respuesta-enviada="fetchModuls" @nuevo-cuestionario="handleNuevoCuestionario"
          @eliminar-cuestionario="handleEliminarCuestionario">
        </CuestionarioCurso>
      </template>
      <v-bottom-navigation>
        <v-btn color="primary" @click="selectModulo(null)">
          <v-icon>mdi-home</v-icon>
          <span>{{ t('inicio') }}</span>
        </v-btn>
        <v-btn icon v-if="!drawer" color="primary" @click.stop="drawer = true">
          <v-icon icon="mdi-dots-horizontal"></v-icon>
          <span>{{ t('navegación') }}</span>
        </v-btn>
        <template v-if="moduloIndex !== null">
          <v-btn @click="selectPreviousLeccion" :disabled="!hasPreviousLeccion">
            <v-icon>mdi-chevron-left</v-icon>
            <span>{{ t('anterior') }}</span>
          </v-btn>
          <v-btn @click="selectNextLeccion" :disabled="!hasNextLeccion">
            <v-icon>mdi-chevron-right</v-icon>
            <span>{{ t('siguiente') }}</span>
          </v-btn>
        </template>
      </v-bottom-navigation>
    </v-row>

    <v-dialog v-model="showDialog" fullscreen persistent>
      <v-card>
        <HelperCarregant v-if="loadingModuls" :missatge="t('Actualizando') + ' ' + t('actividad')" />
        <template v-if="!loadingModuls">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Características_de_la_actividad') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="updateCurso(false)" prepend-icon="mdi-content-save">
              {{ t('Guardar') }}
            </v-btn>
            <v-btn icon @click="showDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel :title="t('Características_generales')">
                  <v-expansion-panel-text>
                    <v-text-field v-model="cursoData.titulo" :label="t('Título')" required></v-text-field>
                    <v-text-field v-model="curso.nombre_director" :label="t('Director')" readonly>
                      <template v-slot:append>
                        <HelpComponent helpType="director"></HelpComponent>
                      </template>
                    </v-text-field>
                    <v-autocomplete multiple v-model="cursoData.director" :items="posibles_administradores"
                      item-title="email" item-value="id" :label="t('Editar') + ' ' + t('Director')">
                    </v-autocomplete>
                    <v-textarea v-model="cursoData.descripcion" :label="t('Descripción')" required>
                      <template v-slot:append>
                        <HelpComponent helpType="descripcion"></HelpComponent>
                      </template>
                    </v-textarea>
                    <v-textarea v-model="cursoData.presentacion" :label="t('Presentación')" required>
                      <template v-slot:append>
                        <HelpComponent helpType="presentacion"></HelpComponent>
                      </template>
                    </v-textarea>
                    <v-file-input v-model="cursoData.imagen" :label="t('Imagen')" prepend-icon="mdi-camera"
                      accept="image/*" @change="handleFileUpload"> <template v-slot:append>
                        <HelpComponent helpType="imagen"></HelpComponent>
                      </template></v-file-input>
                    <!-- Verifica si hay una URL de imagen y muestra el thumbnail -->
                    <v-img :src="cursoData.imagen_thub" height="100" />
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    <template v-slot:default>
                      <v-row no-gutters>
                        <v-col class="d-flex justify-start" cols="4">
                          {{ t('Acceso') }}
                        </v-col>
                        <v-col class="text-grey" cols="8">
                          {{ cursoData.estado_curso }}
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-autocomplete multiple v-model="cursoData.profesionales" :items="tiposProfesionales"
                      item-title="categoria" item-value="id" :label="t('Profesional')">
                      <template v-slot:append>
                        <HelpComponent helpType="profesional"></HelpComponent>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete multiple v-model="cursoData.docentes" :items="posibles_docentes" item-title="email"
                      item-value="id" :label="t('Docentes')">
                      <template v-slot:append>
                        <HelpComponent helpType="docentes"></HelpComponent>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete multiple v-model="cursoData.administradores" :items="posibles_administradores"
                      item-title="email" item-value="id" :label="t('Administradores')">
                      <template v-slot:append>
                        <HelpComponent helpType="administradores"></HelpComponent>
                      </template>
                    </v-autocomplete>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel :title="t('Acceso_regulado_por_email') + ' (' + t('alumnos') + ')'">
                  <v-expansion-panel-text>
                    <v-textarea v-model="emailsRaw"
                      label="Pega los emails de las personas a las que quieras conceder acceso (@vallhebron.cat)"
                      hint="Puedes copiar y pegar los emails seleccionándolos todos a la vez en una columna de Excel"
                      persistent-hint auto-grow :rows="3"></v-textarea>
                    <v-btn @click="updateCurso(true)" prepend-icon="mdi-content-save">
                      {{ t('Guardar') }} {{ t('emails') }}
                    </v-btn>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel :title="t('Características_avanzadas_opcionales')">
                  <v-expansion-panel-text>
                    <v-select multiple v-model="cursoData.rama" :items="tiposRamas" item-title="categoria"
                      item-value="id" :label="t('Áreas')" required>
                      <template v-slot:append>
                        <HelpComponent helpType="areas"></HelpComponent>
                      </template>
                    </v-select>
                    <v-text-field v-model="cursoData.fecha_inicio" :label="t('Fecha_de_inicio')"
                      type="date"></v-text-field>
                    <v-text-field v-model="cursoData.fecha_fin" :label="t('Fecha_de_fin')" type="date"></v-text-field>
                    <v-text-field v-model="cursoData.experiencia_minima" :label="t('Experiencia mínima')"
                      type="number"></v-text-field>
                    <v-text-field v-model="cursoData.experiencia_maxima" :label="t('Experiencia máxima')"
                      type="number"></v-text-field>
                    <v-text-field v-model="cursoData.experiencia_docente" :label="t('Experiencia docente')"
                      type="number"></v-text-field>
                    <v-text-field v-model="cursoData.afos" label="AFOS"> <template v-slot:append>
                        <HelpComponent helpType="afos"></HelpComponent>
                      </template></v-text-field>
                    <v-text-field v-model="cursoData.porcentaje_teorico" label="Porcentaje teórico"> <template
                        v-slot:append>
                        <HelpComponent helpType="porcentaje_teorico"></HelpComponent>
                      </template></v-text-field>
                    <v-checkbox v-model="cursoData.certificado"
                      label="Certificado automático al finalizar"></v-checkbox>
                    <v-checkbox v-model="cursoData.test_requerit_avanzar"
                      label="Se requiere que el usuario complete el test para avanzar de módulo"></v-checkbox>
                    <v-text-field v-model="cursoData.horas" label="Horas"> </v-text-field>
                    <v-btn color="red darken-1" text @click="openDeleteConfirmDialog()">{{ t('Eliminar') }}</v-btn>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteConfirmDialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="text-h5">{{ t('Estás_seguro') }}</v-card-title>
        <v-card-text>
          {{ t('Estás_seguro_que_quieres_eliminar') }} {{ t('la_actividad') }} "{{ curso.titulo }}"? {{
            t('Esta_acción_eliminará_todas') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showDeleteConfirmDialog = false">{{ t('Cancelar') }}</v-btn>
          <v-btn color="red darken-1" text @click="confirmDeleteCurso">{{ t('Eliminar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddDialog" persistent>
      <v-card>
        <HelperCarregant v-if="loadingModuls" :missatge="t('Creando') + ' ' + t('contenido')" />
        <template v-if="!loadingModuls">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Crear') }} {{ t(AddForm.tipus) }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="SubmitNew()" prepend-icon="mdi-content-save">
              {{ t('Guardar') }}
            </v-btn>
            <v-btn icon @click="showAddDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="AddForm.titulo" :label="t('Título')" outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="AddForm.descripcion" :label="t('Descripción')" outlined></v-textarea>
                </v-col>
              </v-row>
              <v-row>Els vídeos, imatges, PDFs i qüestionaris van vinculats a les lliçons. Si vols afegir-ne, ho podràs
                fer en
                un segon temps, editant les lliçons ja creades.</v-row>
            </v-container>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog v-model="helpDialog" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">{{ t('Ayuda') }}</v-card-title>
        <v-card-text>{{ helpText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="helpDialog = false">{{ t('Cerrar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { axios } from '../axios';
import { useUiStore } from '@/stores/ui';
import { useCursosStore } from '@/stores/cursos';

import CuestionarioCurso from './CuestionarioCurso.vue';
import ModuloLeccion from './ModuloLeccion.vue';
import LeccionContent from './LeccionContent.vue';
import HelperCarregant from './HelperCarregant.vue';
import HelpComponent from './HelpComponent.vue'
import EncuestaCurso from './EncuestaCurso.vue'
import ForoCurso from './ForoCurso.vue'

const uiStore = useUiStore();
const cursosStore = useCursosStore();

const { t } = useI18n();
const display = useDisplay();
const drawer = ref(true);
const foroVisible = ref(false);
const noLlegitsForo = ref(0);
let intervalForo = null;

const route = useRoute();
const router = useRouter();
const selectedOptionVista = computed({
  get: () => uiStore.selectedOptionVista,
  set: v => uiStore.setSelectedOptionVista(v),
});
const curso = computed(() => cursosStore.curso || { curso: [] });
const moduls = computed(() => cursosStore.moduls || { modulos: [] });
const encuestascurso = computed(() => cursosStore.encuestascurso || { encuestascurso: [] });
const cursoData = ref({});
const tiposProfesionales = ref([]);
const tiposRamas = ref([]);
const emailsRaw = ref('');
const panel = ref([0, 1]);

const cursoId = ref(route.params.uid);
const moduloIndex = ref(null);
const leccionIndex = ref(-1);
const selectedOption = ref('mirar');
const options = [
  { label: 'Mirar', value: 'mirar', icon: 'mdi-eye' },
  { label: 'Editar', value: 'editar', icon: 'mdi-pencil' }
];
const optionsVista = [
  { label: 'Vista_alumno', value: 'alumno', icon: 'mdi-account' },
  { label: 'Vista_docente', value: 'docente', icon: 'mdi-account-multiple-check' }
];
const showDialog = ref(false);
const showAddDialog = ref(false);
const showDeleteConfirmDialog = ref(false);
const AddForm = ref({
  curso: route.params.uid,
  modulo: null,
  tipus: 'modulos',
  tipo: null,
  titulo: '',
  descripcion: '',
  activo: true,
});
const snackbarText = ref('');
const posibles_docentes = ref([]);
const posibles_administradores = ref([]);
const loadingCurso = computed(() => cursosStore.loadingCurso);
const loadingModuls = computed(() => cursosStore.loadingModuls);
const loadingEncuestas = computed(() => cursosStore.loadingEncuestas);

const hasNextLeccion = computed(() => {
  if (moduloIndex.value == null) return false;
  const isLastLeccionInModulo = leccionIndex.value === moduls.value.modulos[moduloIndex.value].lecciones.length - 1;
  const isLastModulo = moduloIndex.value === moduls.value.modulos.length - 1;
  return !isLastLeccionInModulo || !isLastModulo;
});

const hasPreviousLeccion = computed(() => {
  if (moduloIndex.value == null) return false;
  const isFirstLeccionInModulo = leccionIndex.value === -1;
  const isFirstModulo = moduloIndex.value === 0;
  return !isFirstLeccionInModulo || !isFirstModulo;
});

const currentLeccion = computed(() => {
  if (moduloIndex.value == null || leccionIndex.value == null || leccionIndex.value === -1) {
    return null;
  }
  return moduls.value.modulos[moduloIndex.value].lecciones[leccionIndex.value];
});

const progresoTeorico = computed(() => {
  const tests = (moduls.value?.modulos ?? [])
    .filter(modulo => modulo.tipo === 'alumno')
    .flatMap(modulo => modulo.lecciones ?? [])
    .filter(leccion =>
      leccion.cuestionario != null &&
      leccion.tipo_reto !== 'encuesta'
    );

  const completados = tests.filter(leccion =>
    leccion.nota_usuario?.nota != null
  ).length;

  return {
    total: tests.length,
    completados,
    porcentaje: tests.length
      ? Math.round(completados / tests.length * 100)
      : 0
  };
});

watch(emailsRaw, (newVal) => {
  processPastedEmails(newVal);
});

watch(selectedOption, (newVal, oldVal) => {
  if (oldVal === 'editar' && newVal === 'mirar') {
    cursosStore.fetchCurso(cursoId.value);
  }
});

watch(selectedOptionVista, () => {
  selectModulo(null);
  cursosStore.fetchModuls(cursoId.value);
});

/* Snackbar → uiStore */
function notifyOk(msg) { uiStore.triggerSnackbar({ message: msg, color: 'success' }); }
function notifyError(error) { uiStore.triggerSnackbar({ message: error, color: 'error' }); }

watch(
  () => curso.value.docente_tiene_acceso,
  (tieneAcceso) => {
    if (!tieneAcceso && selectedOptionVista.value !== 'alumno') {
      selectedOptionVista.value = 'alumno'
    }
  }
)

function selectModulo(mI) {
  moduloIndex.value = mI;
  leccionIndex.value = -1; // no lesson selected
}

function selectLeccion(mI, lI) {
  moduloIndex.value = mI;
  leccionIndex.value = lI; // specific lesson
}

function getNextIndices(modulos, currentModuloIndex, currentLeccionIndex) {
  // Copiamos para no mutar parámetros directamente
  let mIndex = currentModuloIndex
  let lIndex = currentLeccionIndex

  if (lIndex === -1) {
    // Si estamos "viendo el módulo", el siguiente paso es la primera lección
    // ... siempre y cuando haya lecciones en este módulo
    if (modulos[mIndex].lecciones.length > 0) {
      lIndex = 0
    } else {
      // Si NO hay lecciones en este módulo, pasamos al siguiente módulo
      // (o paramos si estamos en el último)
      mIndex++
      // Bloqueamos si no hay más módulos o el siguiente está inactivo
      if (mIndex >= modulos.length || !modulos[mIndex].activo) {
        return {
          moduloIndex: currentModuloIndex,
          leccionIndex: currentLeccionIndex,
          canMove: false
        }
      }
      // En el nuevo módulo, empezamos con "ver módulo" (-1) o la primera lección
      lIndex = -1
    }
  } else {
    // Ya estamos en una lección
    lIndex++
    // Si sobrepasamos el número de lecciones, pasamos al siguiente módulo con lIndex = -1
    if (lIndex >= modulos[mIndex].lecciones.length) {
      mIndex++
      // Bloqueamos si no hay más módulos o el siguiente está inactivo
      if (mIndex >= modulos.length || !modulos[mIndex].activo) {
        // No hay siguiente
        return {
          moduloIndex: currentModuloIndex,
          leccionIndex: currentLeccionIndex,
          canMove: false
        }
      }
      // Volvemos a modo módulo del siguiente
      lIndex = -1
    }
  }

  return { moduloIndex: mIndex, leccionIndex: lIndex, canMove: true }
}

function getPreviousIndices(modulos, currentModuloIndex, currentLeccionIndex) {
  let mIndex = currentModuloIndex
  let lIndex = currentLeccionIndex

  if (lIndex === -1) {
    // Estamos viendo "solo módulo"
    // El paso anterior sería la última lección del módulo anterior (o su vista de módulo -1)
    mIndex--
    // Bloqueamos si no hay anterior o si está inactivo
    if (mIndex < 0 || !modulos[mIndex].activo) {
      return {
        moduloIndex: currentModuloIndex,
        leccionIndex: currentLeccionIndex,
        canMove: false
      }
    }
    // En el módulo anterior, si tiene lecciones, vamos a la última
    // o si no, nos quedamos en -1
    if (modulos[mIndex].lecciones.length > 0) {
      lIndex = modulos[mIndex].lecciones.length - 1
    } else {
      lIndex = -1
    }
  } else {
    // Estamos en una lección
    lIndex--
    // Si retrocedemos más allá de la lección 0, tocamos el modo "ver módulo"
    if (lIndex < 0) {
      // Volvemos a la "vista de módulo" del actual
      // (Si prefieres saltar directamente al módulo anterior, ajusta la lógica)
      lIndex = -1
    }
  }

  return { moduloIndex: mIndex, leccionIndex: lIndex, canMove: true }
}

const selectNextLeccion = () => {
  const { moduloIndex: newM, leccionIndex: newL, canMove } = getNextIndices(
    moduls.value.modulos,
    moduloIndex.value,
    leccionIndex.value
  );
  if (!canMove) return;
  moduloIndex.value = newM;
  leccionIndex.value = newL;
};

const selectPreviousLeccion = () => {
  const { moduloIndex: newM, leccionIndex: newL, canMove } = getPreviousIndices(
    moduls.value.modulos,
    moduloIndex.value,
    leccionIndex.value
  );
  if (!canMove) return;
  moduloIndex.value = newM;
  leccionIndex.value = newL;
};

const fetchProfesionales = async () => {
  try {
    const response = await axios.get('profesionales/');
    tiposProfesionales.value = response.data.sort((a, b) => a.categoria.localeCompare(b.categoria));
  } catch (error) {
    console.error(error);
  }
};

const fetchRamas = async () => {
  try {
    const response = await axios.get('ramas/');
    tiposRamas.value = response.data;
  } catch (error) {
    console.error(error);
  }
};

const openEditDialog = () => {
  getCursoData();
  fetchProfesionales();
  fetchPosiblesDocentes();
  fetchPosiblesAdministradores();
  fetchRamas();
  showDialog.value = true;
};

const getCursoData = () => {
  axios.get(`cursos/${curso.value.id}/`)
    .then(response => {
      cursoData.value = response.data;
      cursoData.value.imagen_thub = response.data.imagen;
      cursoData.value.imagen = null;
      emailsRaw.value = cursoData.value.admitidos.join('\n');
    })
    .catch(error => {
      console.error(error);
    });
};

const processPastedEmails = (emailsString) => {
  const emails = emailsString.split(/\r?\n/);
  cursoData.value.admitidos = emails.map(email => email.trim()).filter(email => email);
};

const handleFileUpload = (event) => {
  if (event.target.files && event.target.files.length > 0) {
    cursoData.value.imagen = event.target.files[0];
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        cursoData.value.imagen_thub = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  } else {
    cursoData.value.imagen = null;
  }
};

const updateCurso = (emails) => {
  if (cursoData.value.rama.length === 0) {
    snackbarText.value = 'Debes seleccionar al menos una área en la sección de visibilidad';
    notifyError(snackbarText.value);
    return;
  }
  const formData = new FormData();
  Object.keys(cursoData.value).forEach(key => {
    const value = cursoData.value[key];
    if (value !== null && value !== undefined) {
      if (key === 'imagen' && value instanceof File) {
        formData.append(key, value);
      } else if (key === 'admitidos' && typeof value === 'object') {
        if (emails === true) {
          formData.append(key, JSON.stringify(value));
        }
      } else if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(key, item);
        });
      } else if (key !== 'imagen_thub') { // Solo omitir imagen_thub
        formData.append(key, value);
      }
    }
  });

  axios.put(`cursos/${curso.value.id}/`, formData)
    .then(response => {
      showDialog.value = false;
      snackbarText.value = response.data.titulo + ' ' + 'fue actualizado con éxito';
      notifyOk(snackbarText.value)
      cursosStore.fetchCurso(cursoId.value);
    })
    .catch(error => {
      if (error.response) {
        if (error.response.data.non_field_errors) {
          snackbarText.value = 'Error: ' + error.response.data.non_field_errors.join(', ');
        } else if (error.response.data.detail) {
          snackbarText.value = 'Error: ' + error.response.data.detail;
        } else {
          snackbarText.value = '';
          Object.keys(error.response.data).forEach(key => {
            snackbarText.value += `${key}: ${error.response.data[key].join(', ')}; `;
          });
        }
      }
      notifyError(snackbarText.value);
    });
};

const updateLeccion = () => {
  cursosStore.fetchModuls(cursoId.value);
};

const openDeleteConfirmDialog = () => {
  showDeleteConfirmDialog.value = true;
};

const confirmDeleteCurso = () => {
  axios.delete(`cursos/${curso.value.id}`)
    .then(() => {
      showDialog.value = false;
      showDeleteConfirmDialog.value = false;
      router.push('/inspira');
      snackbarText.value = t("se_ha_eliminado_con_éxito");
      notifyOk(snackbarText.value)
    })
    .catch(error => {
      notifyError(error)
    });
};

const openAddDialog = (tipus, moduloId = null) => {
  AddForm.value.tipus = tipus;
  AddForm.value.titulo = '';
  AddForm.value.descripcion = '';
  if (tipus === 'lecciones') {
    AddForm.value.modulo = moduloId;
  } else {
    AddForm.value.modulo = null;
    AddForm.value.tipo = selectedOptionVista.value;
  }
  showAddDialog.value = true;
};

const SubmitNew = async () => {
  const formData = new FormData();
  Object.keys(AddForm.value).forEach(key => {
    const value = AddForm.value[key];
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });
  await axios.post(`${AddForm.value.tipus}/`, formData).then(response => {
    snackbarText.value = response.data.titulo + ' ' + 'fue creado con éxito';
    notifyOk(snackbarText.value)
    showAddDialog.value = false;
    cursosStore.fetchModuls(cursoId.value);
  }).catch(error => {
    if (error.response) {
      if (error.response.data.non_field_errors) {
        snackbarText.value = 'Error: ' + error.response.data.non_field_errors.join(', ');
      } else if (error.response && error.response.data && typeof error.response.data === 'object') {
        const errors = error.response.data;
        let errorMessage = '';
        Object.keys(errors).forEach(key => {
          errorMessage += `${key}: ${errors[key].join(' ')}\n`;
        });
        snackbarText.value = errorMessage;
      }
    }
    snackbarText.value = error;
    notifyError(error)
  });
};

const handleNuevoCuestionario = () => {
  fetchModuls();
};

const handleEliminarCuestionario = () => {
  fetchModuls();
};

const handleUpdateModulo = () => {
  fetchModuls();
};

const handleDeleteModulo = () => {
  fetchModuls();
};

const handleReorder = (payload) => {
  const { type, index } = payload;
  if (type === 'up' && index > 0) {
    const temp = moduls.value.modulos[index];
    moduls.value.modulos[index] = moduls.value.modulos[index - 1];
    moduls.value.modulos[index - 1] = temp;
  } else if (type === 'down' && index < moduls.value.modulos.length - 1) {
    const temp = moduls.value.modulos[index];
    moduls.value.modulos[index] = moduls.value.modulos[index + 1];
    moduls.value.modulos[index + 1] = temp;
  }
};

const handleReorderL = (payload) => {
  const { type, index } = payload;
  if (type === 'up' && index > 0) {
    const temp = moduls.value.modulos[moduloIndex.value].lecciones[index];
    moduls.value.modulos[moduloIndex.value].lecciones[index] = moduls.value.modulos[moduloIndex.value].lecciones[index - 1];
    moduls.value.modulos[moduloIndex.value].lecciones[index - 1] = temp;
  } else if (type === 'down' && index < moduls.value.modulos[moduloIndex.value].lecciones.length - 1) {
    const temp = moduls.value.modulos[moduloIndex.value].lecciones[index];
    moduls.value.modulos[moduloIndex.value].lecciones[index] = moduls.value.modulos[moduloIndex.value].lecciones[index + 1];
    moduls.value.modulos[moduloIndex.value].lecciones[index + 1] = temp;
  }
};

const fetchPosiblesDocentes = async () => {
  try {
    const response = await axios.get(`curso/${cursoId.value}/posibles_docentes/`);
    posibles_docentes.value = response.data;
  } catch (error) {
    console.error("Error al obtener los posibles docentes:", error);
  }
};

const fetchPosiblesAdministradores = async () => {
  try {
    const response = await axios.get(`curso/${cursoId.value}/posibles_administradores/`);
    posibles_administradores.value = response.data;
  } catch (error) {
    console.error("Error al obtener los posibles administradores:", error);
  }
};

function fetchModuls() {
  cursosStore.fetchModuls(cursoId.value);
}


async function consultarNovetatsForo() {
  if (!curso.value?.id) return;
  try {
    const { data } = await axios.get(`foro/${cursoId.value}/novedades/`);
    noLlegitsForo.value = data.no_leidos;
  } catch (error) {
    // Evitem interrompre l'ús del curs si temporalment falla el fòrum.
    console.error('No es poden consultar les novetats del fòrum', error);
  }
}

watch(() => curso.value?.id, (id) => {
  if (id) consultarNovetatsForo();
});

onMounted(() => {
  cursosStore.fetchCurso(cursoId.value);
  cursosStore.fetchModuls(cursoId.value);
  intervalForo = setInterval(consultarNovetatsForo, 60000);
});

onUnmounted(() => {
  if (intervalForo !== null) clearInterval(intervalForo);
});
</script>